import axios from "axios";
import { getApiBaseUrl } from "../utils/getApiBaseUrl";
import secureStorage from "../utils/secureStorage";

const API_URL = getApiBaseUrl();

const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use(
  (config) => {
    const token = secureStorage.getItem("authToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

const getOrdenesCarga = async () => {
  try {
    const response = await api.get(`${API_URL}ordenCarga`);
    return response.data;
  } catch (error) {
    const message = error?.response?.data?.message || error.message;
    throw new Error(`Error al obtener ordenes de carga: ${message}`);
  }
};

const getOrdenCargaById = async (id) => {
  try {
    const response = await api.get(`${API_URL}ordenCarga/${id}`);
    console.log("🚀 ~ getOrdenCargaById ~ response:", response)
    return response.data;
  } catch (error) {
    const message = error?.response?.data?.message || error.message;
    throw new Error(`Error al obtener la orden de carga: ${message}`);
  }
};

/**
 * Crea una orden de carga con múltiples pedidos
 * @param {Object} payload - { pedidos: [id1, id2, ...], cantidades_asignadas: [n1, n2, ...], fecha_carga, id_cliente, id_vehiculo, motorista_nombre, tara_kg, placas, items, totales }
 */
const postOrdenCarga = async (payload) => {
  try {
    if (!payload.pedidos || !Array.isArray(payload.pedidos) || payload.pedidos.length === 0) {
      throw new Error("El payload debe incluir un array 'pedidos' con al menos un ID");
    }

    const response = await api.post(`${API_URL}ordenCarga`, payload);
    return response.data;
  } catch (error) {
    const message = error?.response?.data?.message || error.message;
    throw new Error(`Error al crear la orden de carga: ${message}`);
  }
};

const patchOrdenCargaStatus = async (id, status) => {
  try {
    const response = await api.patch(`${API_URL}ordenCarga/${id}/status`, { status });
    return response.data;
  } catch (error) {
    const message = error?.response?.data?.message || error.message;
    throw new Error(`Error al actualizar estado de orden de carga: ${message}`);
  }
};

const getPaquetesPorOrden = async (id) => {
  try {
    const response = await api.get(`${API_URL}ordenCarga/${id}/paquetes`);
    console.log("🚀 ~ getPaquetesPorOrden ~ response:", response.data)
    return response.data;
  } catch (error) {
    const message = error?.response?.data?.message || error.message;
    throw new Error(`Error al obtener paquetes de la orden: ${message}`);
  }
};

const liberarOrdenCarga = async (id, data) => {
  try {
    const response = await api.post(`${API_URL}ordenCarga/${id}/liberar`, data);
    return response.data;
  } catch (error) {
    const message = error?.response?.data?.message || error.message;
    throw new Error(`Error al liberar la orden: ${message}`);
  }
};

export { getOrdenesCarga, getOrdenCargaById, postOrdenCarga, patchOrdenCargaStatus, getPaquetesPorOrden, liberarOrdenCarga };
